<template>
  <div class="render">
    <div class="vacate">
      <el-form-item
        :label-width="itemRender.width"
        :label="itemRender.label"
        :required="itemRender.required ? true : false"
      >
        <div class="vacate-item" v-if="itemRender.external">
          <span>实际申请人</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>姓名</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>生效日期</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.department">
          <span>部门</span>
          <el-input
            v-model="itemRender.value"
            placeholder="系统自动获取(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.position">
          <span>职位</span>
          <el-input v-model="itemRender.value" placeholder="请输入"></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.phone">
          <span>手机号</span>
          <el-input v-model="itemRender.value" placeholder="请输入"></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.employee">
          <span>员工类型</span>
          <el-input
            v-model="itemRender.value"
            placeholder="系统自动获取"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.estimate">
          <span>预计入职日期</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.email">
          <span>邮箱</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.number">
          <span>工号</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.extension">
          <span>分机号</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.location">
          <span>办公地点</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.probation">
          <span>试用期</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.regular">
          <span>转正日期</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.postrank">
          <span>岗位职级</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.cardname">
          <span>身份证姓名</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.IDNO">
          <span>证件号码</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.age">
          <span>年龄</span>
          <el-input
            v-model="itemRender.value"
            placeholder="系统计算(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.gender">
          <span>性别</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.first">
          <span>首次参加工作时间</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.working">
          <span>工龄</span>
          <el-input
            v-model="itemRender.value"
            placeholder="系统计算(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.education">
          <span>学历</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.graduate">
          <span>毕业院校</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.graduatetime">
          <span>毕业时间</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.major">
          <span>所学专业</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.bank">
          <span>银行卡号</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.bankname">
          <span>开户行</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.contractcompany">
          <span>合同公司</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.contracttype">
          <span>合同类型</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.contractstart">
          <span>合同起始日</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.contractend">
          <span>合同到期日</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .el-radio {
    margin-bottom: 12px;
  }
}
.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      width: 140px;
    }
  }
  .vacate-item2 {
    background-color: #f7f9ff;
    display: block;
    text-align: center;
    color: #0089ff;
  }
}
.el-form-item {
  position: relative;
  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }
  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }
  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;
    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}
.money {
  .div {
    margin-top: 12px;
  }
}
</style>
